// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"23":"agenda","914":"publishers","963":"event"}[chunkId] + "." + {"23":"29e3e015","914":"f5e5fac4","963":"80bbb736"}[chunkId] + ".css";
};